import { mutations as TYPES } from './types';
import { State } from './state';
import type { TypePage } from '@/app/types/editor/page';
import type { TypeShop } from '@/app/types/editor/shop';

const mutations = {
  /**
   * Reset
   * @param state State
   */
  [TYPES.RESET](_state: State) {
    _state = new State();
  },
  [TYPES.COMMIT_PAGE_INFO](state: State, info: TypePage) {
    state.pageInfo = info;
  },
  [TYPES.COMMIT_PAGE_INFO](state: State, info: TypeShop) {
    state.shopInfo = info;
  },
};

export default mutations;
